import { fetchFlask } from '../../utils/fetchFlask';

export const fetchNegativaveis = async () => {
    const response = await fetchFlask('getNegativaveis');
    return response.negativaveis.length === 0 ? [] : response.negativaveis;
};

export const fetchBaixaveis = async () => {
    const response = await fetchFlask('getBaixaveis');
    return response.baixaveis.length === 0 ? [] : response.baixaveis;
};

export const buildNegativaveisRows = (negativaveis) => negativaveis.map((titulo) => ({
    id: titulo.codigo_lancamento,
    codigo_lancamento: titulo.codigo_lancamento,
    documento: titulo.documento,
    razao_social: titulo.razao_social,
    valor: titulo.valor,
    vencimento: titulo.vencimento
}));

export const buildBaixaveisRows = (baixaveis) => baixaveis.map((titulo) => ({
    id: titulo.codigo_lancamento,
    codigo_lancamento: titulo.codigo_lancamento,
    documento: titulo.documento,
    razao_social: titulo.razao_social,
    valor: titulo.valor,
    data_negativacao: titulo.data_negativacao
}));

export const sumTitulos = (titulos) => titulos.reduce((total, titulo) => total + Number(titulo.valor), 0);
